/**
 * Labels for each wizard step, rendered by HorizontalStepperComponent.
 */
export const WIZARD_STEPS = ['Email', 'BU & Position', 'Role', 'Location', 'Timezone', 'Review'];

/**
 * Roles that require the supervisor field to be visible on Step 3 (Location).
 */
export const SUPERVISOR_VISIBLE_ROLES = ['Agent'];

/**
 * Roles that require the location and client fields to be visible on Step 3.
 */
export const LOCATION_CLIENT_VISIBLE_ROLES = [
    'Agent',
    'Senior Agent',
    'Supervisor',
    'Manager',
    'Client Basic',
    'Client Advanced',
];

/**
 * The Guest role bypasses bucket validation entirely.
 */
export const GUEST_ROLE = 'Guest';

/**
 * Email format validation regex.
 * Matches: local-part (alphanumeric, dots, percent, apostrophe, plus, hyphen)
 *          @ domain (alphanumeric, dots, hyphens) . TLD (2+ alpha chars)
 */
export const EMAIL_REGEX = /^[a-zA-Z0-9._%'+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * Maximum allowed email length per RFC 5321.
 */
export const MAX_EMAIL_LENGTH = 254;

/**
 * Maximum allowed length for first name and last name fields.
 */
export const MAX_NAME_LENGTH = 100;
